<template>
  <div class="animated fadeIn">
    <b-card no-body class="card-default mt-3 vh-85">
      <div slot="header">
        <span>Elementos Eliminados</span>
      </div>
      <b-card-body>
        <NavContent  v-on:styleList="onSelectStyleList($event)">
          <template slot="tituloCabecera">{{materia}}</template>
        </NavContent>
        <slot v-if="typeViewList == 'block'">
            <DirectoriosContent :key="recordsDir._id" class="delete-dir"  :records="recordsDir" @change-dir="changeDataDir($event)" @return-dir="returnDir($event)" />
        </slot>
        <slot v-else-if="typeViewList == 'list'">
          
          <TableContentDirectorios @change-dir="changeDataDir($event)" @return-dir="returnDir($event)" :key="recordsDir._id" :buttons="buttonsBlock" :table-data="recordsDir" :fields="tableFields" :per-page="dataPagination.limit" :show-pagination="false"/>
        </slot>
        <nav>
          <b-pagination
            :total-rows="dataPagination.totalPages"
            :per-page="dataPagination.limit"
            v-model="dataPagination.page"
            prev-text="Anterior"
            next-text="Siguiente"
            hide-goto-end-buttons
            class="paginador-cme"
          />
        </nav>
      </b-card-body>
    </b-card>
  </div>
</template>
<style>
	.card-header-action:hover{
    color: #e3f9ff;
}
.d-block{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fixed{
  max-width: 300px;
}
</style>
<script>
function strip_html_tags(str) {
  if (str === null || str === "") {
    return false;
  } else {
    str = str.toString();
    str = str.replace(/&nbsp;/gi, "");
    str = str.replace(/<[^>]*>/gi, "");
    return str;
  }
}

import MaterialService from "@/services/material.service";
import NavContent from "@/components/NavContent";
import DirectoriosContent from "@/components/DirectoriosContent";
import TableContentDirectorios from "@/components/TableContentDirectorios";
import DirectorioService from '@/services/directorio.service';

export default {
  name: "RecycleBin",
  components: {
    NavContent,
    TableContentDirectorios,
    DirectoriosContent
  },
  data() {
    return {
      materia: "",
      materiaObj: null,
      actualDir: null,
      //materias:this.$store.getters['directorio/getListCursos'],
      user: null,
      recordsDir:new Array,
      //directorios:new Array,
      materiales:new Array,
      arrayBlockElements: new Array(),
      listRecursos: [],
      buttonsBlock: [
        {
          icon: "trash-restore",
          popover: "Restablecer",
          id: "btn-restore"
        }
      ],
      paramsDirs:{
        paginate:true,
        filtro: {
          author: null,
          father: null,
          estatus: 'INACTIVO'
        }
      },
      paramsMtls:{
        paginate:true,
        filtro: {
          author: null,
          father: null,
          estatus: 'INACTIVO'
        }
      },
      dataPaginationDirs: { page:1, totalPages:2 },
      dataPaginationMtls: { page:1, totalPages:2 },
      typeViewList: "block",
      tableFields: [
        { key: "type", label:"", class:'text-center size-icon-tb' },
        { key: "name", label: "Título", tdClass:'nameWidth', sortable: true, class:'text-center' },
        { key: "fechaUltimaActualizacion", label: "Fecha Eliminado", sortable: true, class:'text-center', thStyle: {width: ''} },
        { key: "actions" ,label:"", class:'text-center', thStyle: {width: '10%'}}


      ],
      dataPagination: {
        page: 1,
        limit: 0,
        totalDocs: 0,
        totalPages: 0
      }
    };
  },
  watch: {
    $route(to, from) {
      this.materia = this.$route.params.materia;
      var objCursoPromise = this.$store.dispatch('directorio/getInfoCurso',this.materia);
      objCursoPromise.then(obj => {
        if(obj._id) {
          this.materiaObj = obj;
          this.actualDir = obj;
          this.paramsDirs.filtro.father = this.materiaObj._id;
          this.paramsMtls.filtro.father = this.materiaObj._id;
          this.getRecordsDir(1);
          return 0;
        } else return DirectorioService.list(1,{filtro: { name: this.materia }});
      }).then(response => {
        if(response) {
          this.materiaObj = response[0];
          this.actualDir = response[0];
          this.getRecordsDir(1);
        }
      });
    }
  },
  methods: {
    onSelectStyleList(e) {
      console.log(e);
      switch(e) {
        case 'block':
          this.typeViewList = e;
          break;
        case 'list':
          this.typeViewList = e;
          break;
      }
      //this.typeViewList = e;
    },
    changeDataDir(dir) {
      this.paramsDirs.filtro.father = dir._id;
      this.paramsMtls.filtro.father = dir._id;
      this.actualDir = dir;
      this.getRecordsDir(1);
    },
    returnDir(dir){
      console.log(dir);
      DirectorioService.list(1,{filtro: { _id: dir }}).then(dir => {
        this.actualDir = dir[0];
        this.paramsDirs.filtro.father = dir[0]._id;
        this.paramsMtls.filtro.father = dir[0]._id;
        this.getRecordsDir(1);
      });
    },
    getRecordsDir(page) {
      //this.directorios = new Array;
      this.recordsDir = new Array;
      var arrayPromises = new Array;
      var active = '';
      var orderPromises = ['dirs','mtls'];
      delete this.paramsDirs.filtro.father
      if(page <= this.dataPaginationDirs.totalPages) arrayPromises.push(DirectorioService.list(page, this.paramsDirs));
      else active = orderPromises[1];
      delete this.paramsMtls.filtro.father
      if(page <= this.dataPaginationMtls.totalPages) arrayPromises.push(MaterialService.list(page, this.paramsMtls));
      else active = orderPromises[0];
      Promise.all(arrayPromises).then(responses => {

        if(responses.length > 1) {
          responses.forEach((groupRecs,i,a) => {
            if(!i) {
              this.dataPaginationDirs = JSON.parse(JSON.stringify(groupRecs));
              delete this.dataPaginationDirs.docs;
              //this.directorios = groupRecs.docs;
            }else{
              this.dataPaginationMtls = JSON.parse(JSON.stringify(groupRecs));
              delete this.dataPaginationMtls.docs;
              this.materiales = groupRecs.docs;
            }
            if(groupRecs.docs.length) {
              groupRecs.docs.forEach(rec => {
                rec['typeRec'] = orderPromises[i];
                this.recordsDir.push(rec);
              });
            }

            if(i == a.length - 1) {
              if(this.dataPaginationDirs.totalPages > this.dataPaginationMtls.totalPages) this.dataPagination = this.dataPaginationDirs;
              else this.dataPagination = this.dataPaginationMtls;
            }
            
          });
        }else {
          // cuando uno de los grupos ya no tiene hojas para consultar / ya no tiene que mostrar

          if(active == 'dirs') {
            this.dataPaginationDirs = JSON.parse(JSON.stringify(responses[0]));
            delete this.dataPaginationDirs.docs;
            this.dataPagination = this.dataPaginationDirs;
            //this.directorios = responses[0];
          }else {
            this.dataPaginationMtls = JSON.parse(JSON.stringify(responses[0]));
            delete this.dataPaginationMtls.docs;
            this.dataPagination = this.dataPaginationMtls;
          }

          if(responses[0].docs.length) {
            responses[0].docs.forEach(rec => {
              rec['typeRec'] = active;
              this.recordsDir.push(rec);
            });
          }
        }
      }).catch(err => console.log(err));
    },
    
  },
  created() {
    this.user = this.$store.getters["auth/infoUser"];
    this.materia = this.$route.params.materia;
    var objCursoPromise = this.$store.dispatch('directorio/getInfoCurso',this.materia);
    objCursoPromise.then(obj => {
      if(obj._id) {
        this.materiaObj = obj;
        this.actualDir = this.materiaObj;
        this.paramsDirs.filtro.author = this.user._id;
        this.paramsDirs.filtro.father = this.materiaObj._id;
        this.paramsMtls.filtro.author = this.user._id;
        this.paramsMtls.filtro.father = this.materiaObj._id;
        this.getRecordsDir(1);
        return 0;
      }else return DirectorioService.list(1,{filtro: { name: this.materia }});
    }).then(response => {
      if(response) {
        this.materiaObj = response[0];
        this.actualDir = this.materiaObj;
        this.paramsDirs.filtro.author = this.user._id;
        this.paramsDirs.filtro.father = this.materiaObj._id;
        this.paramsMtls.filtro.author = this.user._id;
        this.paramsMtls.filtro.father = this.materiaObj._id;
        this.getRecordsDir(1);
      }
      this.listRecursos = response.recordsDir;
    });
  },
};
</script>
